<template>
  <div>
    <h1>Avancement des productions de {{ loggedInPrenom }} {{ loggedInNom }}</h1>

    <div class="prod">
      <div class="listeProd">

        <div class="date-range-picker">
          <label for="mh-search">N° affaire :</label>
          <input
            type="text"
            id="mh-search"
            v-model="searchTerm"
            placeholder="Rechercher…"
          >

          <label for="mh-commande">N° de commande :</label>
          <input
            type="text"
            id="mh-commande"
            v-model="commandeTerm"
            placeholder="Rechercher…"
          >

          <label for="mh-start-date">Date de début :</label>
          <input type="date" id="mh-start-date" v-model="startDate" @change="searchProd(1)">

          <label for="mh-end-date">Date de fin :</label>
          <input type="date" id="mh-end-date" v-model="endDate" @change="searchProd(1)">
        </div>

        <div class="hPasse">
          <p>Temps total passé pour cette période : <strong>{{ formatDureeHHMM(tempsTotal) }}</strong> (h:min)</p>
        </div>

        <div v-if="nb_pages > 1" class="pagination container">
          <div class="pagination-pages">
            <span>Page:</span>
            <select @change="searchProd(parseInt($event.target.value))">
              <option v-for="page in nb_pages" :key="page" :value="page" :selected="currentPage === page">{{ page }}</option>
            </select>
            <span>sur {{ nb_pages }}</span>
          </div>
        </div>

        <table class="utilisateursListe mb-5">
          <thead>
            <tr>
              <th @click="handleColumnSort('affaire')"><div class="arrowSort"><span v-if="sortDirection=='asc' && sortColumn=='affaire'"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-up-fill" viewBox="0 0 16 16"><path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"/></svg></span><span v-else><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-down-fill" viewBox="0 0 16 16"><path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/></svg></span><span>Affaire</span></div></th>
              <th @click="handleColumnSort('desa')"><div class="arrowSort"><span v-if="sortDirection=='asc' && sortColumn=='desa'"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-up-fill" viewBox="0 0 16 16"><path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"/></svg></span><span v-else><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-down-fill" viewBox="0 0 16 16"><path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/></svg></span><span>Désignation</span></div></th>
              <th @click="handleColumnSort('client')"><div class="arrowSort"><span v-if="sortDirection=='asc' && sortColumn=='client'"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-up-fill" viewBox="0 0 16 16"><path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"/></svg></span><span v-else><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-down-fill" viewBox="0 0 16 16"><path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/></svg></span><span>Client</span></div></th>
              <th @click="handleColumnSort('etat_prod')"><div class="arrowSort"><span v-if="sortDirection=='asc' && sortColumn=='etat_prod'"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-up-fill" viewBox="0 0 16 16"><path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"/></svg></span><span v-else><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-down-fill" viewBox="0 0 16 16"><path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/></svg></span><span>État de la production</span></div></th>
              <th @click="handleColumnSort('temps')"><div class="arrowSort"><span v-if="sortDirection=='asc' && sortColumn=='temps'"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-up-fill" viewBox="0 0 16 16"><path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"/></svg></span><span v-else><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-down-fill" viewBox="0 0 16 16"><path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/></svg></span><span>Temps passé (h)</span></div></th>
              <th @click="handleColumnSort('quantite')"><div class="arrowSort"><span v-if="sortDirection=='asc' && sortColumn=='quantite'"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-up-fill" viewBox="0 0 16 16"><path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"/></svg></span><span v-else><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-down-fill" viewBox="0 0 16 16"><path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/></svg></span><span>Quantité</span></div></th>
              <th @click="handleColumnSort('signalement')"><div class="arrowSort"><span v-if="sortDirection=='asc' && sortColumn=='signalement'"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-up-fill" viewBox="0 0 16 16"><path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"/></svg></span><span v-else><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-down-fill" viewBox="0 0 16 16"><path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/></svg></span><span>Signalé le</span></div></th>
            </tr>
          </thead>
          <tbody>
            <template v-if="isLoading">
              <tr><td colspan="7" class="text-center">Chargement…</td></tr>
            </template>
            <template v-else-if="filteredProductions.length === 0">
              <tr><td colspan="7" class="text-center">Pas d'opérations enregistrées.</td></tr>
            </template>
            <template v-else>
              <tr
                v-for="(production, index) in filteredProductions"
                :key="production.id"
                class="productions"
                :class="index % 2 === 0 ? 'ligne-claire' : 'ligne-foncee'"
              >
                <td>{{ production.affaire }}</td>
                <td>{{ production.desa }} <br> {{ production.desa2 }} <br> {{ production.desa3 }}</td>
                <td>{{ production.client }}</td>
                <td>{{ production.etat_prod }}</td>
                <td>{{ formatDureeHHMM(production.temps) }}</td>
                <td>{{ production.quantite }}</td>
                <td>{{ formatDate(production.signalement) }}</td>
              </tr>
            </template>
          </tbody>
        </table>

        <div v-if="nb_pages > 1" class="pagination container">
          <div class="pagination-pages">
            <span>Page:</span>
            <select @change="searchProd(parseInt($event.target.value))">
              <option v-for="page in nb_pages" :key="page" :value="page" :selected="currentPage === page">{{ page }}</option>
            </select>
            <span>sur {{ nb_pages }}</span>
          </div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import axios from '@/components/axiosConfig.js';
import VueCookies from 'vue-cookies';
import { formatDureeHHMM } from '@/utils/duree.js';

export default {
  name: 'MesHeuresView',
  data() {
    return {
      productions: [],
      tempsTotal: 0,
      nb_pages: 1,
      currentPage: 1,
      searchTerm: '',
      isLoading: false,
      sortColumn: 'signalement',
      sortDirection: 'desc',
      commandeTerm: '',
      startDate: '',
      endDate: '',
      loggedInEmail: '',
      loggedInNom: '',
      loggedInPrenom: '',
      searchTimeout: null,
    };
  },
  mounted() {
    this.loggedInEmail = VueCookies.get('email') || '';
    this.loggedInNom = VueCookies.get('nom') || '';
    this.loggedInPrenom = VueCookies.get('prenom') || '';
    this.searchProd(1);
  },
  watch: {},
  computed: {
    filteredProductions() {
      const term = this.searchTerm.trim().toLowerCase();
      const commande = this.commandeTerm.trim().toLowerCase();
      return this.productions.filter(p => {
        const matchesTerm = !term || (
          (p.affaire    || '').toLowerCase().includes(term) ||
          (p.desa       || '').toLowerCase().includes(term) ||
          (p.desa2      || '').toLowerCase().includes(term) ||
          (p.desa3      || '').toLowerCase().includes(term) ||
          (p.client     || '').toLowerCase().includes(term) ||
          (p.etat_prod  || '').toLowerCase().includes(term)
        );
        const matchesCommande = !commande || (p.cocde || '').trim().toLowerCase().includes(commande);
        return matchesTerm && matchesCommande;
      });
    },
  },
  methods: {
    formatDureeHHMM,
    searchProd(page) {
      if (!this.loggedInEmail) return;
      this.isLoading = true;
      axios.post('https://www.simef.fr/espace-client/api/getMesHeures.php', {
        page: page,
        searchTerm: '',
        clientEmail: this.loggedInEmail,
        sortColumn: this.sortColumn,
        sortDirection: this.sortDirection,
        startDate: this.startDate,
        endDate: this.endDate,
      })
        .then(response => {
          this.productions = response.data.productions;
          this.tempsTotal = response.data.sumQuantite;
          this.nb_pages = response.data.nb_pages;
          this.currentPage = page;
        })
        .catch(error => console.error(error))
        .finally(() => { this.isLoading = false; });
    },
    handleColumnSort(column) {
      if (this.sortColumn === column) {
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortColumn = column;
        this.sortDirection = 'asc';
      }
      this.searchProd(this.currentPage);
    },
    formatDate(date) {
      if (!date) return '';
      const year = date.substr(0, 4);
      const month = date.substr(5, 2);
      const day = date.substr(8, 2);
      return `${day}-${month}-${year}`;
    },
  },
};
</script>

<style lang="scss">
</style>
